﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';
import { RestService } from 'src/app/_services/rest.service';

@Component({
    template: `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class RecordUserComponent {

    tabla: Tabla = {
        titulo: 'Records',
        endPoint: '/rest-api/user/record',
        editable: true,
        nuevo: false,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 50
            },
            {
                name: 'Categoria',
                prop: 'categoriaDeporte.categoria',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Deporte',
                prop: 'categoriaDeporte.deporte',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Sexo',
                prop: 'alumno.sexo',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 50
            },
            {
                name: 'Alumno',
                prop: 'alumno',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Año',
                prop: 'anio',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Valor',
                prop: 'valor',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100,
                pattern: true
            },
            {
                name: 'Casa',
                prop: 'alumno.casa',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                casa: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Borrado',
                prop: 'delete',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };


}
